/** @typedef {'body' | 'activity' | 'calorie' | 'bfp' | 'bmi'} RankCategory */

/** @type {{ BodyScore: 'body'; StepCount: 'activity'; BurnCal: 'calorie'; BFP: 'bfp'; BMI: 'bmi'; }} */
const CategoryEnum = {
  BodyScore: 'body',
  StepCount: 'activity',
  BurnCal: 'calorie',
  BFP: 'bfp',
  BMI: 'bmi',
}

/** @typedef {'user' | 'manager'} RankSubCategory */

/** @type {{ User: 'user'; Manager: 'manager', }} */
const SubCategoryEnum = {
  User: 'user',
  Manager: 'manager',
}

/**
 * @typedef {object} RankType
 * @property {RankCategory} category
 * @property {RankSubCategory} subCategory
 */

/**
 * @typedef {object} RankItem
 * @property {string} name
 * @property {number} memberSeq
 * @property {string} profile
 * @property {number} value
 * @property {string} managerName
 * @property {number} managerSeq
 * @property {number} memberCount
 */

export {
  // 
  CategoryEnum,
  SubCategoryEnum,
}